export const SALES_DRAFT_QUERY_KEY = "draft";
export const DEFAULT_SALES_DRAFT_ID = "default";

const normalizeDraftId = (value) => {
  const trimmed = String(value || "").trim();
  return trimmed || DEFAULT_SALES_DRAFT_ID;
};

const parseSearch = (search) => {
  const rawSearch = String(search || "");
  return new URLSearchParams(rawSearch.startsWith("?") ? rawSearch.slice(1) : rawSearch);
};

export const createSalesDraftId = () => {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `draft-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
};

export const getSalesDraftIdFromSearch = (search) => {
  const params = parseSearch(search);
  return normalizeDraftId(params.get(SALES_DRAFT_QUERY_KEY));
};

export const isSalesRoutePath = (path) => {
  const pathname = String(path || "").split("?")[0];
  return pathname === "/sales";
};

export const getSalesDraftStorageKey = (search) =>
  `sale-draft:${getSalesDraftIdFromSearch(search)}`;

export const getSalesDraftStorageKeyFromPath = (path) => {
  if (!isSalesRoutePath(path)) return null;
  const [, search = ""] = String(path || "").split("?");
  return getSalesDraftStorageKey(search ? `?${search}` : "");
};

export const buildSalesDraftPath = (draftId) => {
  const normalizedId = normalizeDraftId(draftId);
  if (normalizedId === DEFAULT_SALES_DRAFT_ID) {
    return "/sales";
  }
  const params = new URLSearchParams();
  params.set(SALES_DRAFT_QUERY_KEY, normalizedId);
  return `/sales?${params.toString()}`;
};
